import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Container } from '../styles/Container'
import { breakpoint } from '../layout/styles';
import Button from '../layout/Button';
import CustomSelector, { Selector } from './CustomSelector';

// The InPageNavigation component provides a navigational list of links pointing to headings in the content.
const InPageNavigation = ({ data }) => {
  useEffect(() => {
    // Iterates through the items to assign IDs to matching headings.
    data?.items.forEach((item) => {
      const stringMatch = item.heading_match

      // Fetch all h1-h4 headings in the document.
      const headings = Array.from(document.querySelectorAll("h1, h2, h3, h4"))

      // Iterate through the fetched headings.
      headings.forEach((heading) => {
        // If the heading text matches our item's match string, assign an ID to the heading.
        if (heading.textContent?.includes(stringMatch)) {
          const elId = `${encodeURIComponent(stringMatch.toLowerCase().replace(/ /g, '-'))}-${item._metadata.uid}`
          heading.setAttribute('id', elId)
        }
      })
    })
  }, [data?.items])

  // Handles the select option event on the selector.
  const handleItemSelected = (selectedId: string) => {
    // Find the item using the selectedId
    const selectedItem = data?.items.find(item => item._metadata.uid === selectedId);
    if (selectedItem) {
      const anchorId = `#${encodeURIComponent(selectedItem.heading_match.toLowerCase().replace(/ /g, '-'))}-${selectedId}`;
      // Update the location hash to navigate to the specific section
      window.location.hash = anchorId;
    }
  }

  return (
    <Wrapper>
      <Items>
        {data?.items.map((item) => {
          // Generate a unique ID for each item based on its match string and UID.
          const itemId = encodeURIComponent(item.heading_match.toLowerCase().replace(/ /g, '-')) + '-' + item._metadata.uid
          return <Item key={itemId} data-id={item.id}>
            <Link
              href={`#${itemId}`}
              data-target={item.heading_match}>
              {item.navigation_item_title}
            </Link>
          </Item>
        })}
      </Items>
      <CustomSelector
        selectText={data?.jump_to_text ?? "Jump To"}
        onItemSelected={handleItemSelected}
        items={data.items.map((item) => ({
          id: item._metadata.uid,
          linkTitle: item.navigation_item_title
        }))}
      />

    </Wrapper>
  )
}

export default InPageNavigation

const Wrapper = styled(Container)`
  margin: 36px 20px;
  color: var(--text);
  @media ${breakpoint.desktop} {
    margin: 36px auto 72px;
  }

  ${Selector} {
    @media ${breakpoint.desktop} {
      display: none;
    }
  }
`

const Items = styled.div<any>`
  display: none;
  width: 100%;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;

  @media ${breakpoint.desktop} {
    display: flex;
  }
`

const Item = styled.div<any>``

const Link = styled(Button)`
  display: block;
  font-size: 13px;
  text-decoration: none;
  border-radius: 22px;
  outline: none;
  box-shadow: inset 0 0 0 2px var(--black);
  color: var(--black);
  background-color: transparent;
  transition: all .25s ease 0s;
  transition-property: color, background-color, box-shadow;
  &:hover {
    color: var(--background);
    background-color: var(--black);
    border: none;
  }
`
